import CustomSerialNumberRangePanel from "./customSerialNumberRangePanel.container";

export default CustomSerialNumberRangePanel;
